const prod = {
  url: {
    USER_API_URL: "https://user-api.management.timbercl.com/api/v1",
    API_KEY: "V0VCX1VTRVI6RlJPTlRFTkQ=",
    PWD_RESET_URL:"https://management.timbercl.com/password-reset",
    STOCK_API_URL: "https://transaction-api.management.timbercl.com/api/v1",
    NOTIFICATION_API_URL: "https://notification-api.management.timbercl.com/api/v1",
    NOTIFICATION_API_URL_FOR_SIGNALR: "https://notification-api.management.timbercl.com/messenger",
    PAYMENT_API:"https://pay-api.management.timbercl.com/api/v1"
  }
};

const dev = {
 url: {
  USER_API_URL: "https://user-api.management.timbercl.com/api/v1",
  API_KEY:"REVWX1dFQl9VU0VSOkRFVl9GUk9OVEVORA==",
  PWD_RESET_URL:"http://localhost:3000/password-reset",
  STOCK_API_URL: "https://transaction-api.management.timbercl.com/api/v1",
  NOTIFICATION_API_URL: "https://notification-api.management.timbercl.com/api/v1",
  NOTIFICATION_API_URL_FOR_SIGNALR: "https://notification-api.management.timbercl.com/messenger",
  PAYMENT_API:"https://pay-api.management.timbercl.com/api/v1"

 }
};

// const dev = {
//  url: {
//   USER_API_URL: "https://user-api.testmanagement.timbercl.com/api/v1",
//   API_KEY:"REVWX1dFQl9VU0VSOkRFVl9GUk9OVEVORA==",
//   PWD_RESET_URL:"http://localhost:3000/password-reset",
//   STOCK_API_URL: "https://transaction-api.testmanagement.timbercl.com/api/v1",
//   NOTIFICATION_API_URL: "https://notification-api.testmanagement.timbercl.com/api/v1",
//   NOTIFICATION_API_URL_FOR_SIGNALR: "https://notification-api.testmanagement.timbercl.com/messenger",
//   PAYMENT_API:"https://pay-api.testmanagement.timbercl.com/api/v1"

//  }
// };

export const config = process.env.NODE_ENV === 'development' ? dev : prod;
